import React from 'react';
import '../css/navBar.css';
import '../css/registro.css';

function EncabezadoAdmin(props){



    return(  
        <>  
            <div className='row encabezadoRegistro'>
                <div className='col-sm-10  offset-sm-1'>
                    <h2 className='letraTituloRegistro'>{props.titulo}</h2>   
                    <p className='subtituloRegistro mb-5'>{props.subtitulo}</p>
                </div>
            </div>
               
        </>
    );
}


export default EncabezadoAdmin;